
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/modules/popover/templates/popover"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='arrow'></div>\n<div class='cap'></div>\n<div id='content_region'></div>\n";
},"useData":true});
    }).call(this);
  